import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as Actions from "../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import moment from "moment"
import swal from 'sweetalert'
import captureVideoFrame from "capture-video-frame";
import { isChrome, isFirefox, isSafari, isMobileSafari } from "react-device-detect";
import io from 'socket.io-client';
import Swal from 'sweetalert2'
import { CustomLogger } from '../../../store/actions'
import ManualRomContainer from './ManualRomContainer'
const Rom = props => {
    const dispatch = useDispatch()


    const [IsManualRomEnabled, setIsManualRomEnabled] = useState(false)

    const [Stage, setStage] = useState(1)
    const [ProgressSaved, setProgressSaved] = useState(false)

    const [ShowParts, setShowParts] = useState(false)

    const [SelectedPart, setSelectedPart] = useState(null)

    const [Img1, setImg1] = useState(null)
    const [Img2, setImg2] = useState(null)
    const [Img3, setImg3] = useState(null)

    const [ROMIMAGE1, setROMIMAGE1] = useState(null)
    const [ROMIMAGE2, setROMIMAGE2] = useState(null)

    const [DateOne, setDateOne] = useState(new Date())
    const [DateTwo, setDateTwo] = useState(new Date())
    const [DateThree, setDateThree] = useState(new Date())

    const [AngleForROM0, setAngleForROM0] = useState("")
    const [AngleForROM1, setAngleForROM1] = useState("")
    const [AngleForROM2, setAngleForROM2] = useState("")

    const [ParientName, setParientName] = useState("")


    const [BSROMResult_ID1, setBSROMResult_ID1] = useState("")
    const [BSROMResult_ID2, setBSROMResult_ID2] = useState("")
    const [BSROMResult_ID3, setBSROMResult_ID3] = useState("")

    const [ToBeModifiedID, setToBeModifiedID] = useState(null)
    const [AngleNameToFit, setAngleNameToFit] = useState(null)

    const [ToBeModifiedIDForVideoAttachment, setToBeModifiedIDForVideoAttachment] = useState(null)
    const [ImagePath, setImagePath] = useState(null)
    const UserData = useSelector(({ auth }) => auth.UserData);

    const baseURL = useSelector(({ utils }) => utils.baseURL);
    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const RomParts = useSelector(({ meeting }) => meeting.RomParts)
    const SelectedVideoForROM = useSelector(({ meeting }) => meeting.SelectedVideoForROM);
    // const SelectedVideoForROM = "CHIME_VIDEO_TAG1"
    const IsPatientHashMap = useSelector(({ meeting }) => meeting.IsPatientHashMap);
    const RomSession = useSelector(({ meeting }) => meeting.RomSession);
    const RomFuture = useSelector(({ meeting }) => meeting.RomFuture);


    useEffect(() => {
        props.setStageHere(Stage)

    }, [Stage])

    useEffect(() => {
        return () => {
            DisableImage()
        }
    }, [])

    useEffect(() => {
        // alert(ToBeModifiedID && AngleNameToFit)
        if (ToBeModifiedID && AngleNameToFit) {
            // if (ToBeModifiedID == BSROMResult_ID1) setAngleForROM0(AngleNameToFit)
            if (ToBeModifiedID == BSROMResult_ID2) setAngleForROM1(AngleNameToFit)
            if (ToBeModifiedID == BSROMResult_ID3) setAngleForROM2(AngleNameToFit)

            setToBeModifiedID(null)
            setAngleNameToFit(null)

        }
    }, [ToBeModifiedID, AngleNameToFit])

    useEffect(() => {
        if (ToBeModifiedIDForVideoAttachment && ImagePath) {
            if (ToBeModifiedIDForVideoAttachment == BSROMResult_ID2) setROMIMAGE1(ImagePath)
            if (ToBeModifiedIDForVideoAttachment == BSROMResult_ID3) setROMIMAGE2(ImagePath)
            setToBeModifiedIDForVideoAttachment(null)
            setImagePath(null)
        }
    }, [ToBeModifiedIDForVideoAttachment, ImagePath])

    useEffect(() => {

        AttachSocket()
    }, [])

    useEffect(() => {
        dispatch(Actions.GetttingRomBodyParts())
    }, [])


    function AttachSocket() {
        let isHttps = true;
        const host = `${baseURL}:8080`;
        const socket = io(host)

        CustomLogger("SOCKET:", socket);

        const docID = UserData?.adminDocterId

        if (docID) {

            CustomLogger(`Socket Event attached to BSROMResult_${docID}`)

            socket.on(`BSROMResult_${docID}`, (nodejs_data) => {

                CustomLogger(`Socket data from BSROMResult_${docID}:`, nodejs_data)
                setToBeModifiedID(nodejs_data.bSROMResultId)
                setAngleNameToFit(nodejs_data.angleDegree.toString().substring(0, 4) || 0)


            })
            CustomLogger(`Socket Event attached to VideoVisitAttachment_${docID}`)

            socket.on(`VideoVisitAttachment_${docID}`, (nodejs_data) => {

                CustomLogger(`Socket data from VideoVisitAttachment_${docID}:`, nodejs_data)

                setToBeModifiedIDForVideoAttachment(nodejs_data.isROM)
                setImagePath(nodejs_data.fileName)

            })
        }

    }



    // change the name and extension from API modal
    async function retakePicture(stage) {
        const Yes = await swal("Are you sure?", {
            icon: "warning",
            text: "Are you sure you want to retake picture, all unsaved measurements will be lost !!!",
            buttons: {
                cancel: "Cancel",
                Ok: true,
            }
        })
        if (stage === 3) {
            setROMIMAGE1(null)
            setROMIMAGE2(null)
            ShowAndSendImage(SelectedPart?.initImg)
            setAngleForROM0("")
            setAngleForROM1("")
            setAngleForROM2("")
        }
        if (stage === 4) {
            setROMIMAGE2(null)
            setROMIMAGE1(null)
            ShowAndSendImage(SelectedPart?.angleImg)
            setAngleForROM1("")
            setAngleForROM2("")
        }

        if (stage === 5) {
            setROMIMAGE2(null)
            ShowAndSendImage(SelectedPart?.angle2Img)
            setAngleForROM2("")
        }

        if (Yes) {
            setStage(stage)
        }
    }

    function captureFrame(stage, imgID) {
        const frame = captureVideoFrame(SelectedVideoForROM, "png");

        if (frame.dataUri.length < 10) {

            swal("Please instruct the patient to turn on their camera!", "Patient's camera is off, the screenshot cannot be taken", "error")
            return true
            alert("Didnt came here")
        }
        setStage(stage)

        const NameSpan = document.getElementById(`HoverThingy${parseInt(SelectedVideoForROM.replace("CHIME_VIDEO_TAG", "")) - 1}`)
        setParientName(NameSpan.innerHTML)
        if (stage == 4) {
            dispatch(Actions.startRomSessionWithImage(SelectedPart?.romTypeLkpId, frame.dataUri)).then((res) => {
                setBSROMResult_ID1(res.bSROMResultId)
            })
            setDateOne(new Date())
            return setImg1(frame.dataUri)
        }
        if (stage == 5) {
            dispatch(Actions.creatingMeasurements(SelectedPart?.angleName, frame.dataUri, 2)).then((res) => {
                setBSROMResult_ID2(res.bSROMResultId)
            })
            setDateTwo(new Date())
            return setImg2(frame.dataUri)
        }
        if (stage == 6) {
            dispatch(Actions.creatingMeasurements(SelectedPart?.angleName2, frame.dataUri, 3)).then((res) => {
                setBSROMResult_ID3(res.bSROMResultId)
            })
            setDateThree(new Date())
            return setImg3(frame.dataUri)
        }
    }

    function ShowAndSendImage(img) {
        let PatientLocalID = "";

        if (Object.keys(IsPatientHashMap).length > 0 && SelectedVideoForROM) {

            for (const key in IsPatientHashMap) {

                if (IsPatientHashMap[key]) {

                    if (IsPatientHashMap[key].videoTile == SelectedVideoForROM) {

                        PatientLocalID = IsPatientHashMap[key].UserID
                    }
                }
            }
        }
        if (!PatientLocalID) {
            swal("", "Please enable ROM", "error")
            setStage(1)
            setProgressSaved(false)
            setShowParts(false)
            setSelectedPart(null)
            setImg1(null)
            setImg2(null)
            setImg3(null)
            setROMIMAGE1(null)
            setROMIMAGE2(null)
            setDateOne(new Date())
            setDateTwo(new Date())
            setDateThree(new Date())
            setAngleForROM0("");
            setAngleForROM1("")
            setAngleForROM2("")
            setParientName("");
            setBSROMResult_ID1("")
            setBSROMResult_ID2("")
            setBSROMResult_ID3("")
            setToBeModifiedID(null)
            setAngleNameToFit(null)
            DisableImage()
            return
        }


        dispatch({
            type: Actions.SET_EXERCISE_VIDEO,
            payload: {
                show: true,
                poster: `${baseURL}/images/videocall45/frmbtns/rom_icons/${img}`,
                video: "",
                isROM: true
            }
        })
        const EXERCISE = "EXERCISE"
        meetingSession?.audioVideo.realtimeSendDataMessage(EXERCISE, JSON.stringify({
            show: true,
            poster: `${baseURL}/images/videocall45/frmbtns/rom_icons/${img}`,
            video: "",
            PatientLocalID,
            isROM: true

        }), 100000)

    }

    function DisableImage() {
        dispatch({
            type: Actions.SET_EXERCISE_VIDEO,
            payload: {
                show: false,
                poster: "",
                video: "",
                isROM: true,
            }
        })
        const EXERCISE = "EXERCISE"
        meetingSession?.audioVideo.realtimeSendDataMessage(EXERCISE, JSON.stringify({
            show: false,
            poster: "",
            video: "",
            isROM: true,
            // PatientLocalID,
        }), 100000)

    }



    function SaveInRedux(Is3PartsRequired) {

        // alert(Is3PartsRequired)

        const myArr = Is3PartsRequired ? [
            {
                JoinName: SelectedPart?.romName,
                Deg: AngleForROM0,
                Picture: Img1,
                PatientName: ParientName,
                DateTime: DateOne,
                CorrectAngleName: "Starting",
                // Step: "",
            },
            {
                JoinName: SelectedPart?.romName,
                Deg: AngleForROM1,
                Picture: ROMIMAGE1,
                PatientName: ParientName,
                DateTime: DateTwo,
                CorrectAngleName: SelectedPart?.angleName,
                // Step: "",
            },
            {
                JoinName: SelectedPart?.romName,
                Deg: AngleForROM2,
                Picture: ROMIMAGE2,
                PatientName: ParientName,
                DateTime: DateThree,
                CorrectAngleName: SelectedPart?.angleName2,
                // Step: "",
            },
        ] : [
            {
                JoinName: SelectedPart?.romName,
                Deg: AngleForROM0,
                Picture: Img1,
                PatientName: ParientName,
                DateTime: DateOne,
                CorrectAngleName: "Starting",
                // Step: "",
            },
            {
                JoinName: SelectedPart?.romName,
                Deg: AngleForROM1,
                Picture: ROMIMAGE1,
                PatientName: ParientName,
                DateTime: DateTwo,
                CorrectAngleName: SelectedPart?.angleName,
                // Step: "",
            },
        ]

        dispatch({
            type: Actions.SAVING_ROM_FOR_FUTURE,
            payload: myArr,
        })
    }


    if (IsManualRomEnabled) {
        return (
            <>
                <ManualRomContainer
                    setStageHere={e => props.setStageHere(e)}
                    exitManualRom={() => setIsManualRomEnabled(!IsManualRomEnabled)}

                />
            </>

        )
    }


    return (
        <div className="ROM">
            <div style={{ paddingBottom: "50px" }} className="ROM_CONTAINER">
                <p>
                    Range of motion Evaluation <span onClick={() => {
                        setStage(1)
                        setProgressSaved(false)
                        setShowParts(false)
                        setSelectedPart(null)
                        setImg1(null)
                        setImg2(null)
                        setImg3(null)
                        setROMIMAGE1(null)
                        setROMIMAGE2(null)
                        setDateOne(new Date())
                        setDateTwo(new Date())
                        setDateThree(new Date())
                        setAngleForROM0("");
                        setAngleForROM1("")
                        setAngleForROM2("")
                        setParientName("");
                        setBSROMResult_ID1("")
                        setBSROMResult_ID2("")
                        setBSROMResult_ID3("")
                        setToBeModifiedID(null)
                        setAngleNameToFit(null)
                        DisableImage()
                    }}>(Click here to restart again)</span>
                </p>

                {
                    Stage == 1 ? (
                        <>
                            {/* <span onClick={() => {
                                setShowParts(true)
                                setProgressSaved(false)
                            }} className="SelectJoint">
                                <span>Select a join</span><span className="rotate">^</span>
                            </span> */}

                            <div className="NewROm">
                                {
                                    RomParts?.filter(x => x.romName !== "Manual Draw Angle").map((value, index) => {
                                        return (
                                            <span
                                                key={index}
                                                onClick={() => {
                                                    setStage(2)
                                                    setShowParts(false)
                                                    setSelectedPart(value)

                                                    setProgressSaved(false)
                                                    setImg1(null)
                                                    setImg2(null)
                                                    setImg3(null)
                                                    setROMIMAGE1(null)
                                                    setROMIMAGE2(null)
                                                    setDateOne(new Date())
                                                    setDateTwo(new Date())
                                                    setDateThree(new Date())
                                                    setAngleForROM0("");
                                                    setAngleForROM1("")
                                                    setAngleForROM2("")
                                                    setParientName("");
                                                    setBSROMResult_ID1("")
                                                    setBSROMResult_ID2("")
                                                    setBSROMResult_ID3("")
                                                    setToBeModifiedID(null)
                                                    setAngleNameToFit(null)

                                                    ShowAndSendImage(value.initImg)
                                                }}
                                                className="newRomContainer">
                                                <img
                                                    src={`${baseURL}/images/videocall45/frmbtns/rom_icons/${value.imgFileName}`}
                                                    className="ROMImgNew"
                                                />
                                                <p>
                                                    {value.romName.replace("(", " (")}
                                                </p>
                                            </span>
                                        )
                                    })
                                }
                            </div>

                            <div className="manualDrawButtonContainer">
                                <button onClick={() => {
                                    props.setStageHere(2)
                                    setIsManualRomEnabled(!IsManualRomEnabled)
                                }} className="romNewButton">
                                    + Manual Draw Angle
                                </button>
                            </div>

                        </>
                    ) : null
                }
                {/* {
                    ShowParts ? (
                        <div className="BodyPartsContainer">
                            <span onClick={() => setShowParts(false)} className="CROSS">
                                X
                                    </span>
                            {
                                RomParts.map((value, index) => {
                                    return (
                                        <span
                                            key={index}
                                            onClick={() => {

                                                setStage(2)
                                                setShowParts(false)
                                                setSelectedPart(value)

                                                setProgressSaved(false)
                                                setImg1(null)
                                                setImg2(null)
                                                setImg3(null)
                                                setROMIMAGE1(null)
                                                setROMIMAGE2(null)
                                                setDateOne(new Date())
                                                setDateTwo(new Date())
                                                setDateThree(new Date())
                                                setAngleForROM0("");
                                                setAngleForROM1("")
                                                setAngleForROM2("")
                                                setParientName("");
                                                setBSROMResult_ID1("")
                                                setBSROMResult_ID2("")
                                                setBSROMResult_ID3("")
                                                setToBeModifiedID(null)
                                                setAngleNameToFit(null)

                                                ShowAndSendImage(value.initImg)
                                            }}
                                            className="RomBox">
                                            <img
                                                src={`${baseURL}/images/videocall45/frmbtns/rom_icons/${value.imgFileName}`}
                                                className="ROMImg"
                                            />
                                            <span className="Name">
                                                {value.romName}
                                            </span>
                                        </span>
                                    )
                                })
                            }
                        </div>
                    ) : null
                } */}
                {
                    SelectedPart && !ProgressSaved ? (
                        <span style={{ cursor: Stage == 1 || Stage == 2 ? "pointer" : "default", paddingBottom: isSafari && Stage > 4 ? "140px" : "0px" }} onClick={() => Stage == 1 || Stage == 2 ? setShowParts(true) : null} className="Stage2Select">
                            <span className="RomBox">
                                <img
                                    className="ROMImg"
                                    src={`${baseURL}/images/videocall45/frmbtns/rom_icons/${SelectedPart?.imgFileName}`}
                                />
                                <span className="Name">
                                    {SelectedPart?.romName}
                                </span>
                            </span>
                            {/* {
                                Stage == 1 || Stage == 2 ? (<span className="rotate">^</span>) : null
                            } */}
                        </span>
                    ) : null
                }
                {
                    Stage == 2 ? (
                        <>
                            <button
                                onClick={() => {
                                    setStage(3)
                                }}
                                className="StartMeasuringButton">
                                Start Measuring
                            </button>
                        </>
                    ) : null
                }
                {
                    Stage == 3 ? (
                        <>
                            <span style={{ width: "90%", fontSize: "14px", color: "grey" }}>
                                Step 1- Starting Position: {AngleForROM0}
                            </span>
                            <span style={{ width: "90%", fontSize: "14px", color: "grey", marginTop: "10px" }}>
                                Instruct patient to stay in neutral position, hold, and press “Film Picture” button.
                            </span>
                            <button
                                onClick={async () => {
                                    // setStage(4)
                                    const res = await captureFrame(4, "img1")
                                    if (res === true) return false
                                    ShowAndSendImage(SelectedPart?.angleImg)
                                }}
                                className="StartMeasuringButton">
                                Film Picture
                            </button>
                        </>
                    ) : null
                }
                {
                    Stage >= 4 ? (
                        // true ? (
                        <>
                            <span style={{ width: "90%", fontSize: "14px", color: "grey" }}>
                                Step 1- Starting Position: {AngleForROM0} {AngleForROM0 ? " Deg" : ""}  <span onClick={() => retakePicture(3)} style={{ textDecoration: "underline", cursor: "pointer" }}>Retake Picture</span>
                            </span>
                            <div style={{ width: "90%", marginTop: "10px" }}>
                                <div style={{ width: "50%", position: "relative" }}>
                                    {/* <div className="LoadingRomImg">Measuring</div> */}
                                    {/* <img  style={{ width: "100%" }} src={"/images/background.jpg"} /> */}
                                    <img
                                        onClick={() => {
                                            Swal.fire({
                                                imageUrl: Img1,
                                                imageWidth: 450,
                                                imageAlt: 'A tall image',
                                                showCloseButton: true,
                                                title: "Screenshot"
                                            })
                                        }}
                                        style={{ width: "100%", cursor: "pointer" }} src={Img1} />
                                </div>
                                <span style={{ fontSize: "12px", color: "grey" }}>
                                    {ParientName}-{moment(DateOne).format("MMM DD, YYYY")}

                                </span>
                                <br />
                                <span style={{ fontSize: "12px", color: "grey" }}>
                                    {moment(DateOne).format("HH:mm:SS")}-{SelectedPart?.romName}-Starting
                                </span>
                                <br />
                                <br />
                                <span style={{ width: "90%", fontSize: "14px", color: "grey" }}>
                                    Step 2- {SelectedPart?.angleName}: {AngleForROM1} {AngleForROM1 ? " Deg" : ""} {Stage > 4 && <span onClick={() => retakePicture(4)} style={{ textDecoration: "underline", cursor: "pointer" }}>Measure Again</span>}
                                </span>
                                <br />


                            </div>
                            {
                                Stage == 4 ? (
                                    <>
                                        <span style={{ width: "90%", fontSize: "14px", color: "grey", marginTop: "20px" }}>
                                            Instruct patient to reach the end range of motion, hold, and press “Film and Measure” button.
                                        </span>
                                        <button
                                            disabled={!BSROMResult_ID1}
                                            style={{ background: !BSROMResult_ID1 ? "grey" : "", }}
                                            onClick={async () => {
                                                const res = await captureFrame(5, "img2")
                                                if (res === true) return

                                                if (parseInt(SelectedPart?.numbOfPhotoNeed || 0) >= 3) {

                                                    ShowAndSendImage(SelectedPart?.angle2Img)

                                                } else {
                                                    setStage(7)
                                                    DisableImage()

                                                }
                                            }}
                                            className="StartMeasuringButton">
                                            {
                                                !BSROMResult_ID1 ? "Loading..." : "Film and measure"
                                            }
                                        </button>
                                    </>
                                ) : null
                            }
                        </>
                    ) : null
                }

                {
                    Stage >= 5 ? (
                        <>
                            <div style={{ width: "90%", marginTop: "10px" }}>
                                <div style={{ width: "50%", position: "relative" }}>
                                    {
                                        !ROMIMAGE1 ? (
                                            <div className="LoadingRomImg">Measuring</div>
                                        ) : null
                                    }
                                    <img
                                        onClick={() => {
                                            if (!ROMIMAGE1) return
                                            Swal.fire({
                                                imageUrl: ROMIMAGE1,
                                                // imageHeight: 300,
                                                imageWidth: 450,
                                                imageAlt: 'A tall image',
                                                showCloseButton: true,
                                                title: "Screenshot"
                                            })
                                        }}
                                        style={{ width: "100%", cursor: "pointer" }} src={ROMIMAGE1 || Img2} />
                                </div>
                                <span style={{ fontSize: "12px", color: "grey" }}>
                                    {ParientName}-{moment(DateTwo).format("MMM DD, YYYY")}
                                </span>
                                <br />
                                <span style={{ fontSize: "12px", color: "grey" }}>
                                    {moment(DateTwo).format("HH:mm:SS")}-{SelectedPart?.romName}-{SelectedPart?.angleName}
                                </span>
                                <br />
                                <br />
                                {
                                    parseInt(SelectedPart?.numbOfPhotoNeed || 0) >= 3 ? (
                                        <span style={{ width: "90%", fontSize: "14px", color: "grey" }}>
                                            Step 3- {SelectedPart?.angleName2}: {AngleForROM2} {AngleForROM2 ? " Deg" : ""} {Stage > 5 && <span onClick={() => retakePicture(5)} style={{ textDecoration: "underline", cursor: "pointer" }}>Measure Again</span>}
                                        </span>
                                    ) : null
                                }
                                <br />


                            </div>
                            {
                                Stage == 5 && parseInt(SelectedPart?.numbOfPhotoNeed || 0) >= 3 ? (
                                    <>
                                        <span style={{ width: "90%", fontSize: "14px", color: "grey", marginTop: "20px" }}>
                                            Instruct patient to reach the end range of motion, hold, and press “Film and Measure” button.
                                        </span>
                                        <button

                                            style={{ paddingBottom: isSafari ? "40px" : "10px", marginBottom: "50px" }}
                                            onClick={async () => {
                                                const res = await captureFrame(6, "img3")
                                                if (res === true) return

                                                DisableImage()
                                                setStage(7)
                                            }}
                                            className="StartMeasuringButton">
                                            Film and measure
                                        </button>
                                    </>
                                ) : null
                            }
                        </>
                    ) : null
                }

                {
                    Stage >= 6 && parseInt(SelectedPart?.numbOfPhotoNeed || 0) >= 3 ? (
                        <>
                            <div style={{ width: "90%", marginTop: "10px" }}>
                                <div style={{ width: "50%", position: "relative" }}>
                                    {
                                        !ROMIMAGE2 ? (
                                            <div className="LoadingRomImg">Measuring</div>
                                        ) : null
                                    }
                                    <img
                                        onClick={() => {
                                            if (!ROMIMAGE2) return
                                            Swal.fire({
                                                imageUrl: ROMIMAGE2,
                                                // imageHeight: 300,
                                                imageWidth: 450,
                                                imageAlt: 'A tall image',
                                                showCloseButton: true,
                                                title: "Screenshot"
                                            })
                                        }}
                                        style={{ width: "100%", cursor: "pointer" }} src={ROMIMAGE2 || Img3} />
                                </div>
                                <span style={{ fontSize: "12px", color: "grey" }}>
                                    {ParientName}-{moment(DateThree).format("MMM DD, YYYY")}
                                </span>
                                <br />
                                <span style={{ fontSize: "12px", color: "grey" }}>
                                    {moment(DateThree).format("HH:mm:SS")}-{SelectedPart?.romName}-{SelectedPart?.angleName2}
                                </span>



                            </div>
                        </>
                    ) : null
                }
                {!ProgressSaved ? (
                    <>
                        {

                            parseInt(SelectedPart?.numbOfPhotoNeed || 0) >= 3 && ROMIMAGE1 && ROMIMAGE2 ? <button
                                onClick={() => {
                                    // captureFrame(5, "img2")
                                    // ShowAndSendImage(SelectedPart?.angle2Img)
                                    dispatch(Actions.SaveROM(BSROMResult_ID1, BSROMResult_ID2, BSROMResult_ID3, ParientName))
                                    setProgressSaved(true)
                                    setStage(0)
                                    SaveInRedux(parseInt(SelectedPart?.numbOfPhotoNeed || 0) >= 3 && ROMIMAGE1 && ROMIMAGE2)
                                }}
                                className="StartMeasuringButton">
                                Save measurements
                            </button> : null
                        }
                        {
                            parseInt(SelectedPart?.numbOfPhotoNeed || 0) < 3 && ROMIMAGE1 ? <button
                                onClick={() => {
                                    // captureFrame(5, "img2")
                                    // ShowAndSendImage(SelectedPart?.angle2Img)
                                    dispatch(Actions.SaveROM(BSROMResult_ID1, BSROMResult_ID2, BSROMResult_ID3, ParientName))
                                    setProgressSaved(true)
                                    setStage(0)
                                    SaveInRedux(parseInt(SelectedPart?.numbOfPhotoNeed || 0) >= 3 && ROMIMAGE1 && ROMIMAGE2)
                                }}
                                className="StartMeasuringButton">
                                Save measurements
                            </button> : null
                        }
                    </>
                ) : null

                }
                {
                    ProgressSaved && Stage == 0 ? (
                        <>
                            <span style={{ width: "90%", fontSize: "14px", color: "grey", margin: "10px 0px", fontWeight: "bold" }}>
                                Saved measurements
                            </span>
                            {
                                RomFuture?.map((value, index) => {
                                    return (
                                        <>
                                            <span style={{ width: "90%", fontSize: "14px", color: "grey", marginTop: "10px" }}>
                                                {value.JoinName} {value.CorrectAngleName == "Starting" ? " " : value.CorrectAngleName}
                                            </span>
                                            <div style={{ width: "90%", marginTop: "10px" }}>
                                                <div style={{ width: "50%", position: "relative" }}>
                                                    {/* <div className="LoadingRomImg">Measuring</div> */}
                                                    {/* <img style={{ width: "100%" }} src={"/images/background.jpg"} /> */}
                                                    <img
                                                        onClick={() => {
                                                            Swal.fire({
                                                                imageUrl: value.Picture,
                                                                // imageHeight: 300,
                                                                imageWidth: 450,
                                                                imageAlt: 'A tall image',
                                                                showCloseButton: true,
                                                                title: "Screenshot"
                                                            })
                                                        }}
                                                        style={{ width: "100%", cursor: "pointer" }} src={value.Picture} />
                                                </div>
                                                <span style={{ fontSize: "12px", color: "grey" }}>
                                                    {value.PatientName}-{moment(value.DateTime).format("MMM DD, YYYY")}

                                                </span>
                                                <br />
                                                <span style={{ fontSize: "12px", color: "grey" }}>
                                                    {moment(value.DateTime).format("HH:mm:SS")}-{value.JoinName}-{value.CorrectAngleName}
                                                </span>
                                                <br />
                                                <br />
                                            </div>

                                        </>
                                    )
                                })
                            }
                        </>
                    ) : null
                }


            </div>
        </div>
    )
}

Rom.propTypes = {

}

export default Rom
